import { Container }  from "../components/Container";
import { Benefits } from '../components/Benefits'

// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"

function Contacts(){

    const { i18n } = useTranslation();



    let data = dataFR;
    if (i18n.language === "fr") {
      data = dataFR;
    } else if (i18n.language === "en") {
      data = dataEN;
    } else if (i18n.language ==="nl"){
      data = dataNL;
    }

    
    return(
        <Container>
            <Benefits data={data.contact}/>
        </Container>
    )
}

export default Contacts